module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('p', [_vm._v("大会官方网站内容未经允许，禁止拷贝或转载本站内容，禁止建立类似会议注册页面，否则追究法律责任！")]), _vm._v(" "), _c('p', [_vm._v("技术支持 医点通（北京）信息技术有限公司")]), _vm._v(" "), _c('p', [_vm._v("The contents of the official website of the general assembly are not allowed to copy or reprint, the establishment of a similar meeting registration page is prohibited, otherwise the legal responsibility will be investigated.")]), _vm._v(" "), _c('p', [_vm._v("Technical support by Medcircle")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9fc2105e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/cfooter.vue
// module id = 819
// module chunks = 10